import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const AmountWithSignWrapper = styled.div`
  .positive-sign {
    margin-left: 5px;
    display: inline-block;
    color: ${COLORS.cirrus_green};
  }
  .negative-sign {
    margin-left: 5px;
    display: inline-block;
    color: ${COLORS.cirrus_red};
  }
`;
